import React, {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom'
import { parse } from 'query-string';
import AirtreksFormWidget, { ErrorContent } from '@bit/airtreks.airtreksmedia.airtreks-tp-widget';




function App() {

  const [params, setParams] = useState({
    wtheme: "",
    wtitle: "",
    amb:""
  })

  const [loading, setLoading] = useState(true)

  const location = useLocation();
  
  useEffect(()=> {
    const { wtheme, wtitle, amb } = parse((location || {}).search);

    setParams({
      wtheme,
      wtitle,
      amb
    })

    if (wtheme && wtitle && amb) setLoading(false)
  }, [location])


  const {wtheme, wtitle } = params

  return (

        loading ?  <ErrorContent />  :  
          <>
            <AirtreksFormWidget
              heading={wtitle}
              cta="Next Stop"
              location={location}
              theme={wtheme}
              inlineStyles={{
                height: '95%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}
            /> 
          </>

  );
}

export default App;
